import React, { useState } from 'react';
import i18next from 'i18next';
import { Accessory } from '../../../@types/codegen/types';
import AccessoryCard from '../../../StyledComponents/AccessoryCard';
import Content from '../../../StyledComponents/Content';
import { H2 } from '../../../StyledComponents/Heading';
import { ProductPageMainSection } from '../../../StyledComponents/ProductPage';
import { Repeat } from '../../../StyledComponents/Repeat';
import OverflowGrid from '../../../StyledComponents/OverflowGrid';
import { numberSeparator } from '../../../utils/formats';
import { imageWithWidth } from '../../../utils/image';
import AccesoryModal from './AccesoryModal';

interface AccessoriesSectionProps {
  accessories?: Accessory[];
}

const AccessoriesSection = ({ accessories }: AccessoriesSectionProps) => {
  const [modal, setModal] = useState<Accessory | undefined>();

  const onOpenModal = (accessory: Accessory) => setModal(accessory);
  const onCloseModal = () => setModal(undefined);

  if (!accessories?.length) return null;

  return (
    <ProductPageMainSection>
      {modal && <AccesoryModal accessory={modal} onClose={onCloseModal} />}
      <Repeat>
        <H2 noMargin>{i18next.t('item.accessories.accessories')}</H2>
      </Repeat>
      <Repeat>
        <Content>
          <p>{i18next.t('item.accessories.accessoriesDescription')}</p>
        </Content>
      </Repeat>
      <Repeat>
        <OverflowGrid
          columns={1.05}
          columnsSm={2.1}
          columnsMd={2}
          spacing={2}
          items={accessories.map((accessory) => (
            <AccessoryCard
              key={accessory.id}
              title={accessory.name}
              image={
                accessory.images?.[0]
                  ? {
                      src: imageWithWidth(accessory.images[0], 539, 303),
                      alt: accessory.name,
                    }
                  : undefined
              }
              price={`${numberSeparator(accessory.price)} ${i18next.t('currency.default')}`}
              preamble={accessory.excerpt}
              readMoreCta={() => onOpenModal(accessory)}
            />
          ))}
        />
      </Repeat>
    </ProductPageMainSection>
  );
};

export default AccessoriesSection;
